import type { SubscriptionStore } from "@/Modules/Subscription/Store";
import type { AppStore } from "@/Modules/App/Store";
import type { CancelSubscriptionApiQuery } from "@/Modules/Models/Api/Subscription";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import SubscriptionApiConnector from "@/Services/TherapyApi/Subscriptions";

import useAppStore from "@/Modules/App/Store";

import { log } from "@/Utils/Debug";

class CancelSubscriptionActionHandler {
  constructor(
    private readonly subscriptionStore: SubscriptionStore,
    private readonly appStore: AppStore = useAppStore(),
    private readonly subscriptionApiConnector = new SubscriptionApiConnector()
  ) {}

  public async handle(cancelSubscriptionApiQuery: CancelSubscriptionApiQuery) {
    this.subscriptionStore.isLoading = true;

    return this.subscriptionApiConnector
      .cancelSubscription(cancelSubscriptionApiQuery)
      .then(() => {
        this.appStore.showSnackbar({
          type: NotificationType.SUCCESS,
          message: "settings.subscription.patient.subscription.cancel.success",
        });
      })
      .catch((error) => {
        this.subscriptionStore.notification = {
          type: NotificationType.ERROR,
          message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
          code: "generic error",
        };
        log(error);
      })
      .finally(() => {
        this.subscriptionStore.isLoading = false;
      });
  }
}

export default CancelSubscriptionActionHandler;
